import React from "react";
import Banner from "./Banner.js"
import AboutUs from './AboutUs.js'
import OurTeam from "./OurTeam.js";
import OurBlog from "./OurBlog.js";
import PeopleSay from "./PeopleSay.js";
import Brandlogo from "./Brandlogo.js";
import Carosello from "./Carosello.js";
import ChiSiamo from "./ChiSiamo.js";
import Passaggi from "./Passaggi.js";
import CashCarry from "./CashCarry.js";
import Successo from "./Successo.js";
import Assortimento from "./Assortimento.js";
import Qualita from "./Qualita.js";
import Marchi from "./Marchi.js";
import Iscriviti from "./Iscriviti.js";
export default function Home() {

  return (
    <>
      <Banner/>
      {/* <AboutUs/> */}
      {/* <OurTeam/>  */}
      {/* <OurBlog/> */}
      {/* <Brandlogo/> */}
      <Carosello />
      <ChiSiamo />
      <Passaggi />
      <CashCarry />
      <Successo />
      <Assortimento />
      <Qualita />
      <Marchi />
      <Iscriviti />
    </>
  );
}
